<div class="paginador-redesign">
  <div class="paginador-tamanho">
    <span class="paginador-texto">Exibir</span>
    <div class="paginador-dropdown">
      <button type="button" class="paginador-dropdown-toggle" [class.paginador-dropdown-toggle-aberto]="dropdownAberto()" (click)="alternarDropdown()">
        <span>{{ pageSize }}</span>
        <mat-icon class="paginador-dropdown-seta">expand_more</mat-icon>
      </button>
      @if (dropdownAberto()) {
        <div class="paginador-dropdown-painel">
          @for (opcao of pageSizeOptions; track opcao) {
            <button type="button" class="paginador-dropdown-opcao" [class.paginador-dropdown-opcao-ativa]="opcao === pageSize"
                    (click)="selecionarTamanhoPagina(opcao)">
              {{ opcao }}
            </button>
          }
        </div>
      }
    </div>
    <span class="paginador-texto">registros por página</span>
  </div>

  <div class="paginador-paginas">
    <button type="button" class="paginador-bolinha" [class.paginador-bolinha-desabilitada]="naPrimeiraPagina"
            [disabled]="naPrimeiraPagina" title="Primeira página" (click)="navegar('first')">
      <mat-icon>keyboard_double_arrow_left</mat-icon>
    </button>
    <button type="button" class="paginador-bolinha" [class.paginador-bolinha-desabilitada]="naPrimeiraPagina"
            [disabled]="naPrimeiraPagina" title="Página anterior" (click)="navegar('prev')">
      <mat-icon>chevron_left</mat-icon>
    </button>

    @for (pagina of paginasVisiveis; track $index) {
      @if (pagina === '...') {
        <span class="paginador-reticencias">...</span>
      } @else {
        <button type="button" class="paginador-bolinha paginador-bolinha-numero"
                [class.paginador-bolinha-ativa]="pagina === pageIndex + 1"
                (click)="irParaPagina(pagina)">
          {{ pagina }}
        </button>
      }
    }

    <button type="button" class="paginador-bolinha" [class.paginador-bolinha-desabilitada]="naUltimaPagina"
            [disabled]="naUltimaPagina" title="Próxima página" (click)="navegar('next')">
      <mat-icon>chevron_right</mat-icon>
    </button>
    <button type="button" class="paginador-bolinha" [class.paginador-bolinha-desabilitada]="naUltimaPagina"
            [disabled]="naUltimaPagina" title="Última página" (click)="navegar('last')">
      <mat-icon>keyboard_double_arrow_right</mat-icon>
    </button>
  </div>

  <div class="paginador-info">
    <span class="paginador-texto">{{ inicioRegistro }} - {{ fimRegistro }} de {{ length }} registros</span>
  </div>
</div>
